// TODO: i18n — see Auth.js for pattern, replace hardcoded strings with t('namespace.key')
import { useState } from 'react'
import { supabase } from '../supabase'

const C = {
  bg: '#F2EDE4', card: '#FDFAF6', border: '#DDD4C6',
  amber: '#B8721F', amberLight: '#D4902A', brown: '#2C1D14',
  muted: '#9A7B68',
}
const f = 'Georgia, serif'
const fs = 'Calibri, sans-serif'

export default function ServiceLogModal({ service, propertyId, onClose, onSaved }) {
  const today = new Date().toISOString().split('T')[0]
  const [visitedAt, setVisitedAt] = useState(today)
  const [cost, setCost] = useState(service?.cost ? String(service.cost) : '')
  const [notes, setNotes] = useState('')
  const [loading, setLoading] = useState(false)
  const [focus, setFocus] = useState('')

  const inp = (foc) => ({
    width: '100%', background: C.bg, border: `1px solid ${focus === foc ? C.amber : C.border}`,
    borderRadius: '8px', padding: '11px 14px', fontSize: '15px', fontFamily: f, color: C.brown,
    boxSizing: 'border-box', outline: 'none', marginBottom: '14px', transition: 'border-color 0.2s',
  })
  const lbl = { fontSize: '10px', color: C.muted, letterSpacing: '1.5px', textTransform: 'uppercase', marginBottom: '5px', display: 'block', fontFamily: fs }

  const handleSave = async () => {
    setLoading(true)
    const { error } = await supabase.from('service_logs').insert({
      service_id: service.id,
      property_id: propertyId,
      visited_at: visitedAt,
      cost: cost ? parseFloat(cost) : null,
      notes: notes.trim() || null,
    })
    if (!error) {
      await supabase.from('services').update({ last_service_date: visitedAt }).eq('id', service.id)
    }
    setLoading(false)
    if (!error) onSaved()
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(44,29,20,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100, padding: '20px', fontFamily: f }}
      onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={{ background: C.card, borderRadius: '16px', width: '100%', maxWidth: '400px', boxShadow: '0 8px 40px rgba(44,29,20,0.2)', border: `1px solid ${C.border}` }}>
        <div style={{ padding: '24px 24px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
          <div>
            <div style={{ fontSize: '20px', fontWeight: '700', color: C.brown }}>Log Visit</div>
            <div style={{ fontSize: '13px', color: C.muted, fontFamily: fs, marginTop: '2px' }}>
              {service?.icon && <span style={{ marginRight: '6px' }}>{service.icon}</span>}
              {service?.name}
            </div>
          </div>
          <button style={{ background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer', color: C.muted, padding: 0, lineHeight: 1 }} onClick={onClose}>×</button>
        </div>
        <div style={{ padding: '20px 24px 24px' }}>
          <label style={lbl}>Date of Visit</label>
          <input type="date" style={inp('date')} value={visitedAt} onChange={e => setVisitedAt(e.target.value)} onFocus={() => setFocus('date')} onBlur={() => setFocus('')} />

          <label style={lbl}>Cost <span style={{ textTransform: 'none', letterSpacing: 0 }}>(optional)</span></label>
          <input type="number" placeholder="0" style={inp('cost')} value={cost} onChange={e => setCost(e.target.value)} onFocus={() => setFocus('cost')} onBlur={() => setFocus('')} />

          <label style={lbl}>Notes <span style={{ textTransform: 'none', letterSpacing: 0 }}>(optional)</span></label>
          <textarea
            style={{ ...inp('notes'), resize: 'vertical', minHeight: '70px' }}
            placeholder="Any notes about this visit..."
            value={notes} onChange={e => setNotes(e.target.value)}
            onFocus={() => setFocus('notes')} onBlur={() => setFocus('')}
          />

          <div style={{ display: 'flex', gap: '10px' }}>
            <button style={{ flex: 1, background: 'transparent', border: `1px solid ${C.border}`, borderRadius: '10px', padding: '12px', color: C.muted, fontSize: '13px', cursor: 'pointer', fontFamily: f }} onClick={onClose}>Cancel</button>
            <button
              style={{ flex: 2, background: loading ? C.border : `linear-gradient(135deg, ${C.amber}, ${C.amberLight})`, border: 'none', borderRadius: '10px', padding: '12px', color: loading ? C.muted : C.card, fontSize: '14px', fontWeight: '700', cursor: loading ? 'not-allowed' : 'pointer', fontFamily: f, letterSpacing: '1px', textTransform: 'uppercase' }}
              onClick={handleSave} disabled={loading}
            >
              {loading ? 'Saving...' : 'Save Visit'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
